// extracted by mini-css-extract-plugin
module.exports = {"arrow":"ki","dropMenu":"kj","dropMenuInner":"kk","itemborder":"kl","dropDownCurrent":"km","menuItem":"kn","langContainer":"ko","current":"kp","outlink":"kq"};